<template>
  <div class="d-flex flex-column justify-content-end w-100" role="group" :aria-labelledby="labelId">
    <label
      v-if="model.vars.label"
      :id="labelId"
      :class="
        'form-label' + (model.vars.label_attr && model.vars.label_attr.class ? ' ' + model.vars.label_attr.class : '')
      "
    >
      {{ model.vars.label }}
      <span
        v-if="model.vars.help && !isMobile()"
        v-tooltip="{ title: model.vars.help, textWrap: true }"
        class="form-info ms-1"
      >
        <FontAwesomeIcon icon="fa-light fa-circle-question" />
      </span>
    </label>
    <div v-if="isMobile() && model.vars.help" class="form-info">
      <FontAwesomeIcon icon="fa-light fa-circle-question" />
      {{ model.vars.help }}
    </div>
    <p class="mail-status-field">
      <MailStatusChipComponent v-if="hasStatus" :mailStatus="mailStatus" @open="opened = true" />
      <MailStatusEmptyComponent v-else />
    </p>
    <MailStatusModalComponent
      :opened="opened"
      :mailStatus="mailStatus"
      @hidden="opened = false"
      @unblocked="markAsValid"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import MailStatusChipComponent from "@/components/mailStatus/MailStatusChipComponent.vue";
import MailStatusEmptyComponent from "@/components/mailStatus/MailStatusEmptyComponent.vue";
import MailStatusModalComponent from "@/components/mailStatus/MailStatusModalComponent.vue";
import { mailStatusManager } from "@/services/mail-status/mail-status-manager";

export default {
  name: "MailStatusTypeComponent",
  components: { FontAwesomeIcon, MailStatusChipComponent, MailStatusEmptyComponent, MailStatusModalComponent },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      opened: false,
      mailStatus: null,
    };
  },
  computed: {
    labelId() {
      return `${this.model.vars.id}-label`;
    },
    hasStatus() {
      return (this.mailStatus?.status ?? null) !== null;
    },
  },
  watch: {
    model: {
      immediate: true,
      handler() {
        this.mailStatus = this.buildMailStatus();
      },
    },
  },
  methods: {
    isMobile() {
      return window.innerWidth < 992;
    },

    /*
     * Copie et non la référence de `model.vars.value` : un déblocage manuel repasse le statut à
     * « Valide » en mutant l'objet affiché, ce qui modifierait sinon la prop du formulaire et
     * désynchroniserait le payload soumis de ce que le back a réellement renvoyé.
     */
    buildMailStatus() {
      const value = this.model?.vars?.value;

      return value ? { ...value } : null;
    },

    markAsValid() {
      mailStatusManager.markAsValid(this.mailStatus);
    },
  },
};
</script>

<style lang="scss" scoped>
.mail-status-field {
  padding: 8px 10px;
  border: 1px solid $m-color_3;
  border-radius: 6px;
  background: $m-color_20;
  margin-bottom: 0;

  @include dark-theme {
    border-color: $m-color_12;
    background: $m-color_10;
  }
}
</style>
